<template>
    <el-container>
        <slot name="left"></slot>
        <div :hidden="hidden" v-for="(item, index) in addDesignDataSourceList" :key="item" style="margin-right: 10px;text-align:center">
            <td-button v-if="index == 0" type="primary" :loading="loading" @click="dynamicBtnChild(item.sSeriesButtonList, item.sButtonName, item.sId)">{{ item.sButtonName }}</td-button>
            <td-button v-if="index != 0" :loading="loading" @click="dynamicBtnChild(item.sSeriesButtonList, item.sButtonName, item.sId)">{{ item.sButtonName }}</td-button>
        </div>
        <slot></slot>
        <slot name="right"></slot>
        <div :hidden="defaultBtnHidden">
            <td-button type="button" @click="dialogLeaveBillClose">{{ $t('pgCommon.CLOSE') }}</td-button>
        </div>
    </el-container>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: {
        type: {
            type: String,
            default: function() {
                return 'primary';
            }
        },
        defaultBtnHidden: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        sIng: {
            type: String,
            default: function() {
                return '';
            }
        },
        dynamicBtn: {
            type: Function,
            default: null
        },
        cancel: {
            type: Function,
            default: null
        },
        loading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        proDefId: {
            type: String,
            default: function() {
                return '';
            }
        }
    },
    created() {
        this.init();
    },
    data() {
        return {
            addDesignDataSourceList: []
        };
    },
    methods: {
        dialogLeaveBillClose() {
            this.cancel();
        },
        compare(arg) {
            return function(a, b) {
                return a[arg] - b[arg];
            };
        },
        init() {
            if (this.sIng == '') {
                return;
            }
            let param = {
                sIgn: this.sIng,
                sProDefId: this.proDefId
            };
            api.getSteSeriesButtonDataBySIgn(param, response => {
                let temp = [];
                let temp1 = [];
                temp = response.data.content;
                for (let i = 0; i < temp.length; i++) {
                    let param = {
                        sButtonName: temp[i].sButtonName,
                        sSeriesButtonList: JSON.parse(temp[i].sSeriesButtonList),
                        iButtonOrder: temp[i].iButtonOrder,
                        sId: temp[i].sId
                    };
                    temp1.push(param);
                }
                this.addDesignDataSourceList = temp1.sort(this.compare('iButtonOrder'));
            });
        },
        dynamicBtnChild(sSeriesButtonList, btnName, btnId) {
            this.dynamicBtn(sSeriesButtonList, btnName, btnId);
        }
    }
};
</script>
